import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';
export default function PrivacyPolicy() {
    return (
<main class="privacy-policy">

    <div class="privacy-container">

        <p class="policy-update">POLICY UPDATES 1ST JAN 2026</p>

        <h2>ANNEXURE</h2>

        <h2>PERSONAL DATA USAGE</h2>

        <p>
            This section addresses individual user specifics, crucial for differentiating Dentulu users.
            Examples include:
        </p>

        <h3>Data Collection and Purpose:</h3>

        <ul>
            <li><strong>First and last name:</strong> App functionality, Security, Account management</li>
            <li><strong>Address</strong></li>
            <li><strong>Email address (Optional):</strong> Account management</li>
            <li><strong>User IDs:</strong> App functionality, Analytics, Personalization, Account management</li>
            <li><strong>Telephone number</strong></li>
            <li><strong>Other private data (Optional):</strong> Analytics</li>
        </ul>

        <p>
            Users may provide specific information during website use, as requested or aligned with this Privacy Policy.
        </p>

        <h2>LOCATION TRACKING</h2>

        <p>
            Using Dentulu involves location data recording.
        </p>

        <h2>COUNSELING COMMUNICATIONS</h2>

        <p>
            All exchanges between users and medical professionals remain confidential,
            except for instances involving court orders for criminal matters.
        </p>

        <h2>IMAGE DATA (PHOTOS AND VIDEOS)</h2>

        <h3>Data Collection and Purpose:</h3>

        <ul>
            <li><strong>Videos (Optional):</strong> App functionality</li>
            <li><strong>Photos (Optional):</strong> App functionality</li>
        </ul>

        <p>
            Our app, available at
            <a href="https://app.dentulu.com/" target="_blank" rel="noopener noreferrer">
                https://app.dentulu.com/
            </a>,
            may collect user images for various purposes, such as profile pictures or content submissions.
            Please note that any images you submit may be securely stored on our servers for future use.
            However, it's important to emphasize that we do not share these images with third parties;
            they are solely used for internal purposes aimed at enhancing our services and improving the
            overall user experience. By submitting an image, you acknowledge and provide your consent to
            our image collection and storage.
        </p>

        <p>
            Additionally, our app may also store or collect files in formats such as
            .doc, .docs, .pdf, .xls, and .xlsx for various functionalities and features.
        </p>

        <h2>APP USAGE DATA</h2>

        <h3>Data Collection and Purpose:</h3>

        <ul>
            <li><strong>App interactions:</strong> Analytics, Personalization</li>
            <li><strong>In-app search history:</strong> App functionality, Analytics, Personalization</li>
            <li><strong>Other actions:</strong> App functionality, Analytics, Personalization</li>
        </ul>

        <h2>COOKIES</h2>

        <p>
            Users should note that "cookies" may automatically collect information and data.
            These are small text files used by websites to identify and monitor user behavior,
            gather general information, and guide advertising strategies. Cookies don't harm files
            and don't attach to user systems. Users can accept or reject cookies through most browsers
            to control information collection.
        </p>

        <h2>UPDATE OR DELETE INFORMATION</h2>

        <p>
            Users can update, change, or correct data via the feedback form on the website or software.
            Upon request, we'll strive to delete user data from our databases, although full deletion
            might not be feasible due to support data or deleted records due to health care policies
            according to HIPAA needs to be stored for 7 years.
        </p>

        <h2>PRIVACY POLICY CHANGES</h2>

        <p>
            We reserve the right to modify or update the Privacy Policy at any time.
            Continued use of our services signifies acceptance of these policies.
        </p>

        <h2>CONTENT OWNERSHIP</h2>

        <p>
            All Dentulu content, including text, graphics, logos, icons, images, videos, downloadable
            items, data, and content created by Dentulu, is part of Dentulu's property. Unauthorized
            use may result in legal action. Additionally, the services' names and scripts exclusively
            belong to Dentulu, and any commercial use without written permission may lead to legal consequences.
        </p>

        <p>
            <strong>SMS Communications:</strong>
            By providing your phone number, you consent to receive SMS messages from your dental office
            via the Dentulu platform. Message and data rates may apply. Message frequency varies.
            Reply STOP to opt out, HELP for help. View our full terms at
            <a href="https://app.dentulu.com/page/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                app.dentulu.com/page/terms-and-conditions
            </a>.
        </p>



        <h1>DENTULU INC PRIVACY POLICY</h1>

        <p>
            This Privacy Policy specifically applies to how Dentulu collects, uses, and discloses
            the information you provide to Dentulu or that Dentulu obtains with your consent as a
            result of your use of the Application or your enrollment as a registered user with Dentulu.
            This Privacy Policy does not apply to information provided directly to Dentulu Directors
            from you, or any other third-party on your behalf, which is covered by the Notice of Privacy
            Practices for Dentulu Dental Hygienists.
        </p>

        <p>
            DENTULU, Inc. (“Dentulu”, “we”, “us”, or “our”) operates the website located at
            www.Dentulu.com, other related websites and mobile applications (collectively, the “Site”).
            Through these sites, we operate various online services that enable members (“Members”)
            to receive telehealth (Teledental) services from dental providers located in the U.S..
            This Online Privacy Policy (“Privacy Policy”) explains Dentulu’s privacy practices that
            apply to the services (collectively, the “Services”) we provide through our Sites.
        </p>

        <p>
            Please read the Privacy Policy carefully so that you can understand how Dentulu collects,
            uses, and discloses information from and/or about you when you use a Site or the Services.
            If you do not understand any aspect of our Privacy Policy, please feel free to contact
            using the information found at the end of the Privacy Policy.
        </p>

        <p>
            This Privacy Policy is a part of the Dentulu Terms of Use so by accepting the Terms of Use,
            you are consenting to the use and disclosure of your personal information as outlined in
            this Privacy Policy.
        </p>


        <h2>1. User Information and Other Information That You Give Us</h2>

        <p>
            If you submit, upload, post or transmit any health information, medical history, conditions,
            problems, symptoms, personal information, consent forms, agreements, requests, comments,
            ideas, suggestions, information, files, videos, images or other materials to us or our Site
            (“User Information”), you agree not to provide any User Information that (1) is false,
            inaccurate, defamatory, abusive, libelous, unlawful, obscene, threatening, harassing,
            fraudulent, pornographic, or harmful, or that could encourage criminal or unethical behaviour,
            (2) violates or infringes the privacy, copyright, trademark, trade dress, trade secrets or
            intellectual property rights of any person or entity, or (3) contains or transmits a virus
            or any other harmful component.
        </p>

        <p>
            You agree not to contact other site users through unsolicited e-mail, telephone calls,
            mailings or any other method of communication. You represent and warrant to Dentulu and
            its Providers that you have the legal right and authorization to provide all User Information
            to Dentulu and its Providers for use as set forth herein and required by Dentulu and the Provider.
        </p>

        <p>
            When you register for the Application or enrol as a Dentulu registered user (“Enroll”),
            or login to the Application or Dentulu website to create a profile, comment on articles,
            or complete surveys, we collect personal information that can identify you (“Personally
            Identifiable Information” or “PII”), such as your full name, email address, mailing address,
            telephone number, and credit card information for payment.
        </p>

        <p>
            In addition to PII, Dentulu may also collect the protected Health information
            (“Protected Health Information” or “PHI”) of you or of an individual for which you are
            requesting Health services.
        </p>

        <p>
            Ultimately, the information that Dentulu collects varies depending upon how you use our
            Services and what permissions you give to us and other third-parties that also collect
            your PII and/or PHI.
        </p>

        <p>
            We will not use any PHI for any other purpose without your explicit authorization,
            or unless otherwise permitted or required by law. You may revoke, in writing, any such
            authorization at any time, except to the extent we have taken action in reliance thereon.
        </p>

        <p>
            Notwithstanding, it is important to understand that Dentulu does not have any independent
            access to Dentulu Dental Hygienists and/or Dentists detailed dental records of its patients
            that may be created as a result of a Visit.
        </p>

        <p>
            WE DO NOT KNOWINGLY ENROLL OR COLLECT INFORMATION DIRECTLY FROM CHILDREN UNDER THE AGE OF EIGHTEEN.
        </p>


        <h2>HIPAA and Confidentiality of Health Information</h2>

        <p>
            The healthcare providers and Dental Professionals from the Dentulu’s platform that you
            interact with when using the Services are required by the Health Insurance Portability
            and Accountability Act (“HIPAA”) to describe their privacy practices in document called
            a Notice of Privacy Practices.
        </p>

        <p>
            Certain Dental Practices and Physicians may be subject to laws and regulations governing
            the use and disclosure of Health information they create or receive. Included among them
            is the Health Insurance Portability and Accountability Act of 1996 (“HIPAA”), the Health
            Information Technology for Economic and Clinical Health of 2009 (“HITECH”), and the regulations
            adopted thereunder, and applicable state laws.
        </p>


        <h2>Other Information We Collect</h2>

        <h3>Cookies</h3>

        <p>
            Our Application may use cookies and other technologies to collect information.
            Cookies are small bits of information that our websites place on the hard drive of your computer.
            We may use cookies to facilitate your login processes; allow you to personalize and store your
            settings; collect usage information; determine our total audience size and traffic; and help
            us improve our sites by measuring which areas are of greatest interest to users.
        </p>

        <h3>Tracking and/or Analytics Services</h3>

        <p>
            We may use mobile application tracking and/or analytics services. These services may record
            unique mobile gestures such as tap, double-tap, zoom, pinch, scroll, swipe and tilt but do
            not collect personally identifiable information that you do not voluntarily enter in the Application.
        </p>

        <h3>Web Beacons</h3>

        <p>
            We may also use web beacons (invisible images often referred to as pixel tags or clear GIFs)
            in order to recognize users and assess traffic patterns, and we may include web beacons and
            cookies in our email messages in order to count how many e-mail messages have been opened.
        </p>

        <h3>Non-Personally Identifiable Information</h3>

        <p>
            We also collect Non-Personally Identifiable Information that is not Health information or
            Dental information in the form of statistics and information regarding the Application user’s
            statistics and metrics obtained from third party devices.
        </p>

        <h3>Mobile Device Information</h3>

        <p>
            Your use of the Application may also include the collection of information from your mobile device.
            For example, the Application may request your permission to collect location data and/or may request
            access to multimedia (photos or videos) stored on your mobile device.
        </p>


        <h2>The Personal Information we collect or maintain may also include:</h2>

        <ol>
            <li>Your name, age, email address, username, password, and other registration information.</li>
            <li>Health Information that you provide us, which may include information or records relating to your medical or health history, health status and laboratory testing results, diagnostic images, and other health related information.</li>
            <li>Health information about you prepared by the health care provider(s) who provide the Services through the Site such as medical records, treatment and examination notes, and other health related information.</li>
            <li>Billing information that you provide us.</li>
            <li>Information about the computer or mobile device you are using, such as what Internet browser you use, the kind of computer or mobile device you use, and other information about how you use the Site.</li>
            <li>Other information you input into the Site or related services.</li>
        </ol>


        <h2>How We Use Your Information</h2>

        <p>
            Subject to this Privacy Policy, the Terms of Service, and applicable terms and conditions
            of third-party applications, all data transmitted through the Application or website is
            owned by Dentulu; provided, however, that PHI that you provide for the purpose of scheduling
            a Visit with a Dental Practice will be solely owned by the Dental Practice.
        </p>

        <p>Generally, we may use information in the following ways:</p>

        <ul>
            <li>For the purposes for which you specifically provided it including, without limitation, to enable us to process your registration, provide the Services or other requests.</li>
            <li>To transmit a request for a Visit per your request.</li>
            <li>To send you information about your relationship or transactions with us.</li>
            <li>To notify you about our products, services, and special offers, except that we will not use PHI for marketing purposes without your prior written consent for yourself or your minor child.</li>
            <li>To otherwise contact you with information that we believe will be of interest to you.</li>
            <li>To enhance or develop features, products and services. To allow us to personalize the content that you and others see on the Application.</li>
            <li>To provide advertisers and other third parties with aggregate information about Application users and Application usage patterns.</li>
            <li>To allow other select companies to send you promotional materials about their products and services, provided that no PHI will be used for this purpose without your prior written consent.</li>
        </ul>


        <h2>1. Sharing Your Information</h2>

        <p>
            Except as otherwise described in this Privacy Policy, or if we inform you otherwise at the
            time of data collection and receive your consent where required, we will not sell, trade,
            or share your information with third parties.
        </p>

        <p>We may share your information as follows:</p>

        <ul>
            <li><strong>Visits:</strong> We will share your information, at your direction, to transmit a request for a Visit with Dentulu Dental Hygienists.</li>
            <li><strong>With Affiliates:</strong> We may share your information with affiliated companies and businesses.</li>
            <li><strong>With Service Dental Hygienists:</strong> We may use other companies to perform services including processing credit card transactions, sending emails, fulfilling purchase requests, and data analysis.</li>
            <li><strong>With Business Partners:</strong> When you make purchases or engage in promotions offered through our Application, we may share PII, but not your PHI, with the businesses with which we partner.</li>
            <li>To our wholly owned subsidiary, Breakthrough, and affiliated medical/Dental groups.</li>
            <li>To contractors, service providers and other third parties we use to support our business.</li>
            <li>As required by law, which can include providing information as required by law, regulation, subpoena, court order, legal process or government request.</li>
            <li>When we believe in good faith that disclosure is necessary to protect your safety or the safety of others.</li>
            <li>To a buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution or other sale or transfer of some or all of Dentulu’s assets.</li>
        </ul>


        <h2>Confidentiality of Health Information</h2>

        <p>
            Certain Dental Practices and Physicians may be subject to laws and regulations governing
            the use and disclosure of Health information they create or receive. Included among them
            is the Health Insurance Portability and Accountability Act of 1996 (“HIPAA”), the Health
            Information Technology for Economic and Clinical Health of 2009 (“HITECH”), and the regulations
            adopted thereunder, and applicable state laws.
        </p>


        <h2>How to Access or Update Your Information</h2>

        <p>
            You have the ability to review and update your personal information by visiting the account
            management section on the Application. You can also review and update your personal information
            by contacting us at the email address provided below in the “How to contact us” section of this
            Privacy Policy.
        </p>


        <h2>How We Protect Your Information</h2>

        <p>
            We use commercially reasonable administrative, technical, and physical measures to safeguard
            your information in our possession against loss, theft and unauthorized use, disclosure or
            modification. We follow generally accepted industry standards to protect the information
            submitted to us, both during transmission and once we receive it.
        </p>

        <p>
            No method of transmission over the internet is 100% secure, however. Therefore, while we
            strive to make all reasonable efforts to use commercially acceptable means to protect your
            personal information, we cannot guarantee its absolute security.
        </p>


        <h2>Deletion of Information</h2>

        <p>
            You can close your online account by emailing us at
            <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
            If you close your account, we will no longer use your online account information or share
            it with third parties. We may, however, retain a copy of the information for archival purposes,
            and to avoid identity theft or fraud.
        </p>


        <h2>Changes To Our Privacy Policy</h2>

        <p>
            Dentulu reserves the right to modify these Terms of Use at any time, effective upon posting.
            Any use of this website after such changes will be deemed an acceptance of those changes.
        </p>

        <p>
            Dentulu uses Google Analytics, a third-party tracking service, which uses cookies to track
            non-personal identifiable information about our visitors on the aggregate to capture usage
            and volume statistics.
        </p>

        <p>
            From time to time we may revise this Privacy Policy. If we make revisions that change the way
            we collect or use your information, those changes will be posted in this Privacy Policy and
            the effective date will be noted at the end of the Privacy Policy.
        </p>


        <h2>Children’s Online Privacy Protection Act</h2>

        <p>
            We support and comply with the Children’s Online Privacy Protection Act (COPPA) and we do not
            knowingly collect information from children under the age of 18, nor do we share such information
            with third parties. Children under the age of 18 may not use the Application.
        </p>


        <h2>Links to Third Party Sites</h2>

        <p>
            Our Application or website may contain links to websites or applications operated and maintained
            by third-parties, over which we have no control. Privacy policies for these third-party sites
            and applications may be different from our Privacy Policy.
        </p>


        <h2>11. How to Contact Us</h2>

        <p>
            If you have any questions, comments or concerns about our Privacy Policy, you may contact us at
            <a href="mailto:support@Dentulu.com">support@Dentulu.com</a>
            or by writing a letter to:
        </p>
        
        <address>
            Dentulu, Inc.
            Attn: General Counsel
            2002 South Burlington Avenue
            Los Angeles, CA 90007
        </address>


        <h2>12. Effective Date</h2>

        <p>
            This Privacy Policy is effective as of April 1st, 2019.
        </p>




        <h1>NOTICE OF PRIVACY PRACTICES</h1>

        <p class="version"><strong>Version 2026.2</strong></p>

        <div class="important-notice">
            <strong>
                IMPORTANT NOTICE TO PATIENTS:
            </strong>
            This Notice describes how medical and dental information about you may be used and disclosed,
            and how you can get access to this information. Please review it carefully. This Notice is
            required by the Health Insurance Portability and Accountability Act of 1996 (HIPAA), as amended
            by the Health Information Technology for Economic and Clinical Health (HITECH) Act of 2009,
            and applicable federal and state law.
        </div>


        <h2>I. WHO WE ARE — PLATFORM IDENTITY &amp; ROLE CLARIFICATION</h2>

        <p>
            <strong>
                Dentulu Inc. (“Dentulu,” “we,” “us,” or “our”) is a national technology platform and
                healthcare marketplace facilitator providing teledentistry, dental marketplace, remote-care,
                AI-enabled oral health, medical-dental integration, and care-coordination services.
                Dentulu operates as a HIPAA Covered Entity and, where applicable, as a Business Associate.
            </strong>
        </p>

        <p>
            <strong>
                PLATFORM NATURE DISCLOSURE — PLEASE READ CAREFULLY:
            </strong>
            Dentulu is a technology platform and marketplace that facilitates connections between patients
            and independently licensed dental and medical providers.
            <strong>DENTULU IS NOT A DENTAL OR MEDICAL PRACTICE.</strong>
            Dentulu does not itself render clinical diagnoses, treatment, or professional dental or medical opinions.
        </p>


        <h3>A. Independent Contractor Provider Relationships</h3>

        <p>
            The licensed dentists, dental hygienists, dental specialists, physicians, nurse practitioners,
            physician assistants, and other licensed healthcare professionals available through the Dentulu
            platform (“Network Providers”) are, unless otherwise expressly stated, independent contractors
            and not employees, agents, partners, or joint venturers of Dentulu.
        </p>

        <ul>
            <li>Network Providers operate under their own professional licenses, state board authorities, and clinical practice standards;</li>
            <li>Network Providers exercise independent professional judgment in rendering clinical services and are solely responsible for their clinical decisions, diagnoses, prescriptions, treatment plans, and all clinical outcomes;</li>
            <li>Dentulu does not direct, supervise, or control the clinical judgment or professional practice of Network Providers;</li>
            <li>The patient-provider relationship is formed directly between the patient and the treating Network Provider, not with Dentulu;</li>
            <li>Dentulu is not responsible for the clinical acts, errors, omissions, malpractice, negligence, or professional misconduct of any Network Provider;</li>
            <li>Network Providers carry their own professional liability (malpractice) insurance and are credentialed in accordance with applicable state licensure requirements;</li>
            <li>The mere fact that Dentulu facilitates a patient’s connection to a Network Provider does not create an employment relationship, agency, or vicarious liability for that provider’s clinical conduct.</li>
        </ul>

        <p>
            Nothing in this Notice or in Dentulu’s platform operations creates a duty of care by Dentulu
            with respect to the clinical services rendered by independent Network Providers.
        </p>


        <h3>B. Dentulu’s Operational Role</h3>

        <p>Within the scope of its platform operations, Dentulu does:</p>

        <ul>
            <li>Maintain a HIPAA-compliant infrastructure for the secure transmission and storage of PHI;</li>
            <li>Facilitate scheduling, communication, billing, and care coordination between patients and providers;</li>
            <li>Provide technology tools including AI-assisted triage, oral health screening, and clinical decision support for use by licensed providers;</li>
            <li>Operate as a Business Associate where it receives, transmits, or maintains PHI on behalf of covered entity providers; and</li>
            <li>Coordinate care navigation and administrative support services.</li>
        </ul>


        <table class="policy-table">
            <tbody>
                <tr>
                    <th>Privacy Officer</th>
                    <td>Chief Privacy Officer, Dentulu Inc.</td>
                </tr>
                <tr>
                    <th>Contact Email</th>
                    <td><a href="mailto:support@dentulu.com">support@dentulu.com</a></td>
                </tr>
                <tr>
                    <th>Legal Inquiries</th>
                    <td><a href="mailto:legal@dentulu.com">legal@dentulu.com</a></td>
                </tr>
                <tr>
                    <th>Phone</th>
                    <td>888-905-0226</td>
                </tr>
                <tr>
                    <th>Address</th>
                    <td>2002 South Hoover Street, Los Angeles, CA 90007</td>
                </tr>
                <tr>
                    <th>Website</th>
                    <td>
                        <a href="https://www.dentulu.com/privacypractices.html"
                           target="_blank"
                           rel="noopener noreferrer">
                            www.dentulu.com/privacypractices
                        </a>
                    </td>
                </tr>
                <tr>
                    <th>Effective Date</th>
                    <td>January 1, 2026</td>
                </tr>
                <tr>
                    <th>Version</th>
                    <td>2026.2</td>
                </tr>
            </tbody>
        </table>


        <h2>II. OUR DUTIES AND COMMITMENT</h2>

        <p><strong>We are required by law to:</strong></p>

        <ul>
            <li>Maintain the privacy and security of your PHI;</li>
            <li>Provide you with this Notice of our legal duties and privacy practices;</li>
            <li>Notify you following a breach of your unsecured PHI;</li>
            <li>Abide by the terms of this Notice currently in effect; and</li>
            <li>Not use or disclose PHI in a manner inconsistent with this Notice.</li>
        </ul>


        <h2>III. PROTECTED HEALTH INFORMATION — WHAT WE COLLECT</h2>

        <p>
            “Protected Health Information” (PHI) includes individually identifiable information relating
            to your past, present, or future physical or mental health condition, the provision of healthcare
            to you, or payment for healthcare, in any form — oral, written, or electronic (“ePHI”).
        </p>

        <p>Dentulu may collect, create, maintain, and use PHI including but not limited to:</p>

        <ul>
            <li>Personal identifiers (name, date of birth, address, Social Security Number, government ID numbers);</li>
            <li>Contact information (phone, email, IP addresses, device identifiers);</li>
            <li>Dental and oral health history, diagnoses, treatment plans, clinical notes, X-rays, photographs, intraoral scan data, and imaging records;</li>
            <li>Medical history, medications, allergies, vitals, and co-morbidities relevant to dental or medical-dental integration care;</li>
            <li>Insurance, benefits, claims, billing, and financial records;</li>
            <li>Teledentistry session recordings, transcripts, and AI-generated triage notes;</li>
            <li>Prescription and pharmacy records;</li>
            <li>Laboratory, pathology, and imaging results;</li>
            <li>Patient portal messages, appointment records, and communications;</li>
            <li>Device and platform usage data where associated with your identity; and</li>
            <li>Any other information used or disclosed in connection with your care.</li>
        </ul>


        <h2>IV. HOW WE MAY USE AND DISCLOSE YOUR PHI</h2>

        <p>
            Federal law permits us to use and disclose your PHI for the following purposes without your
            written authorization. We apply the minimum necessary standard to all such uses and disclosures.
        </p>


        <h3>A. Treatment</h3>

        <p>
            We may use and disclose your PHI to provide, coordinate, and manage your dental and oral health
            care and related services, including:
        </p>

        <ul>
            <li>Synchronous and asynchronous teledentistry consultations with licensed Network Providers;</li>
            <li>Care coordination and referrals among network providers, dental offices, specialty clinics, imaging centers, laboratories, pharmacies, and physician networks;</li>
            <li>AI-assisted clinical decision support and symptom triage for use by licensed providers;</li>
            <li>Remote monitoring, medical-dental integration, emergency treatment coordination, peer review, and specialist consultations.</li>
        </ul>


        <h3>B. Payment</h3>

        <p>
            We may use and disclose your PHI to obtain payment for treatment and services, including billing
            insurers, verifying eligibility, obtaining prior authorizations, processing appeals, revenue
            cycle management, collections, and payer audits.
        </p>


        <h3>C. Healthcare Operations</h3>

        <p>
            We may use and disclose your PHI for general healthcare operations, including quality assurance,
            credentialing, utilization management, accreditation, training programs, legal and audit services,
            fraud detection and prevention, platform development and testing, care coordination, customer
            service, due diligence in mergers and acquisitions, and other operational functions necessary
            to run Dentulu.
        </p>


        <h2>V. OTHER PERMITTED USES AND DISCLOSURES WITHOUT AUTHORIZATION</h2>

        <h3>A. Required by Law</h3>
        <p>Disclosure is made when required by federal, state, or local law, court orders, or administrative orders.</p>

        <h3>B. Public Health Activities</h3>
        <p>Disclosures to public health authorities for disease control, injury reporting, adverse event reporting, and risk notification.</p>

        <h3>C. Health Oversight Activities</h3>
        <p>Disclosures to government agencies for audits, investigations, inspections, and licensure proceedings.</p>

        <h3>D. Judicial and Administrative Proceedings</h3>
        <p>Disclosures in response to court orders, subpoenas, discovery requests, or other lawful legal process.</p>

        <h3>E. Law Enforcement</h3>
        <p>Disclosures to law enforcement officials as permitted or required by law.</p>

        <h3>F. Serious Threats to Health or Safety</h3>
        <p>Use or disclosure to prevent or lessen a serious and imminent threat to health or safety.</p>

        <h3>G. Workers’ Compensation</h3>
        <p>Disclosures as required to comply with workers’ compensation or similar programs.</p>

        <h3>H. Research</h3>
        <p>Use or disclosure for research approved by an IRB or Privacy Board, or where appropriate waivers have been obtained, or where de-identified as required by HIPAA.</p>

        <h3>I. Fundraising</h3>
        <p>
            We may contact you using limited PHI for fundraising. You have the right to opt out at any time
            by emailing <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
        </p>

        <h3>J. Health Information Exchanges</h3>
        <p>
            We may participate in health information exchanges (HIEs) for treatment purposes, subject to
            your opt-out rights where applicable.
        </p>

        <h3>K. Business Associates</h3>
        <p>
            We may share your PHI with Business Associates who perform services on our behalf.
            All Business Associates execute HIPAA-compliant Business Associate Agreements (BAAs).
        </p>


        <h2>VI. THIRD-PARTY SHARING — PLATFORM ECOSYSTEM &amp; LIABILITY FRAMEWORK</h2>

        <h3>A. Third-Party Sharing Categories</h3>

        <p>
            Dentulu may share your PHI, to the extent permitted by HIPAA, with:
        </p>

        <ul>
            <li>Licensed Dentists, Dental Specialists, Hygienists, and Oral Surgeons in the Dentulu provider network;</li>
            <li>Dental Offices, Group Practices, and Dental Service Organizations (DSOs);</li>
            <li>Dental Laboratories for prosthetics, orthodontic appliances, and dental devices;</li>
            <li>Pharmacies and Pharmacy Benefit Managers (PBMs) for prescription fulfillment;</li>
            <li>Dental and Medical Imaging Centers for diagnostic imaging and radiology;</li>
            <li>Medical Physicians, NPs, PAs, and licensed medical providers for medical-dental integration;</li>
            <li>Hospitals, Health Systems, and Emergency Care Facilities for referrals and integrated care;</li>
            <li>Medical Billing Companies and Revenue Cycle Management (RCM) vendors;</li>
            <li>Health Insurers, Dental Insurers, Managed Care Organizations, and Government Payers (Medicare, Medicaid, CHIP);</li>
            <li>Care Coordinators, Patient Navigators, and Case Managers;</li>
            <li>Technology Vendors providing EHR, practice management, scheduling, and telehealth platform services;</li>
            <li>API Partners and Software Vendors for platform interoperability;</li>
            <li>Cloud Computing and Data Storage Providers;</li>
            <li>Security, Compliance, and Audit Vendors;</li>
            <li>AI/Machine Learning Vendors operating as Business Associates under BAAs;</li>
            <li>Subcontractors operating under a Business Associate Agreement; and</li>
            <li>Any entity with which Dentulu maintains a current, valid Business Associate Agreement.</li>
        </ul>


        <h3>B. Third-Party Liability Limitation</h3>

        <div class="notice-box">
            <strong>THIRD-PARTY INDEPENDENCE NOTICE:</strong>
            Each third party in the Dentulu ecosystem — including Network Providers, dental offices,
            imaging centers, pharmacies, laboratories, billing companies, technology vendors, AI vendors,
            API partners, and subcontractors — operates as an independent entity subject to its own legal
            obligations, professional standards, licensure requirements, and contractual agreements.
            <strong>
                DENTULU IS NOT RESPONSIBLE FOR THE ACTS, OMISSIONS, ERRORS, SECURITY PRACTICES, PRIVACY
                PRACTICES, OR COMPLIANCE FAILURES OF ANY THIRD PARTY,
            </strong>
            except to the extent expressly required by HIPAA’s Business Associate provisions.
        </div>

        <p>Specifically:</p>

        <ul>
            <li>Once PHI is disclosed to a Network Provider for treatment purposes as permitted by HIPAA, that provider is solely responsible for its own handling and protection of that PHI;</li>
            <li>Dentulu’s execution of a BAA with a Business Associate creates contractual obligations between those parties but does not make Dentulu liable for a Business Associate’s independent acts or failures in the absence of Dentulu’s own negligence;</li>
            <li>Third-party vendors, technology providers, and API partners are each independently responsible for their own security and privacy controls, subject to their BAAs with Dentulu;</li>
            <li>Dentulu does not warrant or guarantee the security, privacy, or compliance posture of any third-party system, platform, or service; and</li>
            <li>Dentulu does not sell your PHI. We do not share PHI with advertisers, data brokers, or marketing companies in ways that constitute a sale of PHI under HIPAA or applicable state law.</li>
        </ul>


        <h2>VII. AI, AUTOMATION, AND DATA ANALYTICS — RISK ALLOCATION &amp; DISCLOSURES</h2>

        <p>
            Dentulu is a technology-forward healthcare platform that uses artificial intelligence (AI),
            machine learning (ML), natural language processing (NLP), automation, and advanced data analytics
            to support clinical operations and improve platform performance.
        </p>


        <h3>A. AI-Supported Clinical Functions</h3>

        <ul>
            <li>Symptom triage and pre-visit intake processing for routing patients to appropriate providers;</li>
            <li>AI-assisted oral health screening, dental image analysis, and risk scoring for review by licensed providers;</li>
            <li>Clinical decision support tools that surface relevant clinical flags for licensed provider review;</li>
            <li>Care-gap identification and preventive care reminders;</li>
            <li>Risk stratification for chronic disease management and population health programs;</li>
            <li>AI-assisted documentation, clinical note summarization, and coding support; and</li>
            <li>Predictive analytics for care coordination and patient engagement workflows.</li>
        </ul>

        <div class="critical-notice">
            <strong>CRITICAL AI DISCLOSURE — NO CLINICAL WARRANTIES:</strong>
            ALL AI TOOLS AND AUTOMATED SYSTEMS ON THE DENTULU PLATFORM ARE CLINICAL DECISION-SUPPORT TOOLS ONLY.
            DENTULU MAKES NO WARRANTIES, EXPRESS OR IMPLIED, REGARDING THE ACCURACY, COMPLETENESS, RELIABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, OR CLINICAL APPROPRIATENESS OF ANY AI OUTPUT, RECOMMENDATION,
            SCORE, FLAG, ANALYSIS, OR AUTOMATED RESULT.
        </div>


        <h3>B. Clinical Judgment — Provider Responsibility</h3>

        <ul>
            <li>AI tools are designed exclusively to assist — and under no circumstances replace — the independent, licensed clinical judgment of dental and medical professionals;</li>
            <li>All clinical diagnoses, treatment decisions, treatment plans, prescriptions, and recommendations are made solely by the treating licensed Network Provider, not by any AI system or automated process;</li>
            <li>Network Providers are independently responsible for reviewing, validating, accepting, modifying, or rejecting any AI-generated output, flag, or recommendation before acting upon it;</li>
            <li>A Network Provider’s reliance on, or failure to review, AI-generated outputs is within the sole professional responsibility of that provider and does not create liability for Dentulu;</li>
            <li>Dentulu does not guarantee that AI tools will be available, error-free, or uninterrupted at any given time; and</li>
            <li>Dentulu is not liable for clinical decisions made by Network Providers that were informed by, or contrary to, AI-generated clinical decision support.</li>
        </ul>


        <h3>C. AI Output Limitations — Patient Acknowledgment</h3>

        <ul>
            <li>AI-powered triage, screening, and symptom assessment tools are not diagnostic tools and do not constitute a medical or dental diagnosis;</li>
            <li>AI-generated results, scores, and assessments are preliminary, informational, and subject to review and validation by a licensed provider;</li>
            <li>AI tools may produce false positives, false negatives, or inaccurate results due to limitations in training data, image quality, input data quality, or other technical factors;</li>
            <li>Patients should not rely solely on AI-generated outputs to make healthcare decisions and should always seek the advice of a qualified licensed dental or medical professional; and</li>
            <li>Emergency dental or medical conditions should always be evaluated in person or at an emergency facility, and AI triage results should never substitute for emergency care.</li>
        </ul>


        <h3>D. HIPAA-Compliant AI Infrastructure</h3>

        <ul>
            <li>All AI vendors with access to PHI operate under current, valid Business Associate Agreements;</li>
            <li>PHI in AI systems is subject to the same access controls, encryption, audit logging, and minimum-necessary safeguards as other PHI within Dentulu’s infrastructure;</li>
            <li>AI model inference and training on identifiable PHI requires authorization where mandated by HIPAA or applicable state law (see Addendum B); and</li>
            <li>De-identified data used in AI model training is de-identified in compliance with HIPAA’s Safe Harbor or Expert Determination methods (45 C.F.R. § 164.514(b)).</li>
        </ul>


        <h3>E. Limitation of Liability — AI Systems</h3>

        <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, DENTULU SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES ARISING FROM: (i) THE USE OF
            OR RELIANCE ON ANY AI-GENERATED OUTPUT, RECOMMENDATION, SCORE, OR ANALYSIS; (ii) ERRORS,
            OMISSIONS, OR INACCURACIES IN ANY AI OR AUTOMATED SYSTEM OUTPUT; (iii) FAILURE, UNAVAILABILITY,
            OR INTERRUPTION OF ANY AI OR AUTOMATED SYSTEM; OR (iv) ANY CLINICAL DECISION MADE BY A NETWORK
            PROVIDER IN RELIANCE ON OR CONTRARY TO AI-GENERATED OUTPUTS.
        </p>


        <h2>VIII. DE-IDENTIFIED, AGGREGATED &amp; DERIVED DATA — DATA RIGHTS</h2>

        <p>
            Dentulu may create, generate, or derive data from your PHI by removing or altering identifying
            information in accordance with HIPAA’s Expert Determination (45 C.F.R. § 164.514(b)(1)) or Safe
            Harbor (45 C.F.R. § 164.514(b)(2)) de-identification standards.
        </p>


        <h3>A. Dentulu’s Data Rights — Scope, Duration &amp; Commercialization</h3>

        <p>
            With respect to properly de-identified, aggregated, anonymized, pseudonymized, statistical,
            derivative, or non-PHI data (collectively, “Derived Data”), Dentulu claims and retains the
            following rights, which are perpetual, irrevocable, worldwide, royalty-free, fully paid-up,
            sublicensable, and transferable:
        </p>

        <ul>
            <li>The exclusive right to use, reproduce, process, adapt, modify, publish, transmit, distribute, perform, display, and otherwise exploit Derived Data for any lawful purpose;</li>
            <li>The right to develop, train, validate, test, improve, and commercialize artificial intelligence models, machine learning algorithms, predictive analytics engines, clinical benchmarking systems, and related technologies using Derived Data;</li>
            <li>The right to create, own, license, sublicense, sell, transfer, or otherwise commercialize derivative works, statistical outputs, population health analytics, clinical insights, industry benchmarks, and aggregated reports based on Derived Data;</li>
            <li>The right to retain Derived Data indefinitely as a proprietary business asset of Dentulu Inc. without limitation of time or use;</li>
            <li>The right to share Derived Data with research institutions, public health agencies, industry partners, investors, acquirers, and successors without restriction; and</li>
            <li>The right to include Derived Data in Dentulu’s intellectual property portfolio, assign or license such rights, and include them in any sale, merger, or acquisition of Dentulu or any of its business units.</li>
        </ul>


        <h3>B. No Compensation Owed</h3>

        <p>
            Patients are not entitled to, and Dentulu shall not owe, any compensation, royalty, revenue share,
            or other remuneration in connection with Dentulu’s use of Derived Data for any purpose, including
            without limitation AI model development, commercial licensing, or sale of analytics products.
        </p>


        <h3>C. Ownership of Platform-Generated Data</h3>

        <p>
            Dentulu owns all platform-generated data, including metadata, usage logs, platform interaction
            data, session data, aggregate clinical quality metrics, and any other data that does not constitute
            PHI or is properly de-identified. Nothing in HIPAA limits Dentulu’s right to use such non-PHI platform data.
        </p>


        <h3>D. PHI Ownership Clarification</h3>

        <p>
            <strong>IMPORTANT CLARIFICATION:</strong>
            Dentulu does not claim ownership of your identifiable PHI beyond the use and disclosure rights
            expressly permitted by HIPAA. Your PHI remains subject to your patient rights as described in
            Section IX of this Notice.
        </p>


        <h3>E. Survival</h3>

        <p>
            The rights granted in this Section VIII shall survive the termination of any patient relationship,
            account closure, deletion of a patient account, or revocation of any consent or authorization.
        </p>


        <h2>IX. YOUR RIGHTS REGARDING YOUR PHI</h2>

        <div class="important-notice">
            <strong>PATIENT RIGHTS — FULLY PRESERVED:</strong>
            The patient rights in this Section are required by federal HIPAA law and are not modified,
            limited, or waived by any other provision of this Notice or any companion document.
        </div>


        <h3>A. Right to Access and Inspect Your PHI</h3>
        <p>
            You have the right to inspect and obtain a copy of PHI about you in your Designated Record Set (DRS).
            We will provide access in the form and format requested where readily producible, including electronic format.
        </p>

        <h3>B. Right to Amend Your PHI</h3>
        <p>
            You have the right to request amendment of PHI in your DRS if inaccurate or incomplete.
            If we deny, you may submit a statement of disagreement to be included in your record.
        </p>

        <h3>C. Right to an Accounting of Disclosures</h3>
        <p>
            You have the right to an accounting of disclosures of your PHI made in the six years prior to your request,
            excluding disclosures for treatment, payment, healthcare operations, and certain other categories.
        </p>

        <h3>D. Right to Request Restrictions</h3>
        <p>
            You have the right to request restrictions on use or disclosure of your PHI.
        </p>

        <h3>E. Right to Confidential Communications</h3>
        <p>
            You have the right to request we communicate with you in a specific way or at a specific location.
            We will accommodate reasonable requests.
        </p>

        <h3>F. Right to a Paper Copy of This Notice</h3>
        <p>
            You have the right to receive a paper copy of this Notice at any time upon request.
            Contact <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
        </p>

        <h3>G. Right to Breach Notification</h3>
        <p>
            You have the right to notification in the event of a breach of your unsecured PHI,
            within 60 days of discovery.
        </p>

        <h3>H. Right to Opt Out of Fundraising</h3>
        <p>
            You have the right to opt out of fundraising communications.
            Email <a href="mailto:support@dentulu.com">support@dentulu.com</a> to opt out.
        </p>

        <h3>I. Right to File a Complaint</h3>
        <p>
            If you believe your privacy rights have been violated, you may file a complaint with Dentulu’s
            Privacy Officer at <a href="mailto:support@dentulu.com">support@dentulu.com</a>, or with the
            U.S. Department of Health &amp; Human Services, Office for Civil Rights (OCR) at
            <a href="https://www.hhs.gov/ocr" target="_blank" rel="noopener noreferrer">
                www.hhs.gov/ocr
            </a>,
            1-800-368-1019, or 200 Independence Ave. S.W., Washington, D.C. 20201.
            We will not retaliate against you for filing a complaint.
        </p>


        <div class="notice-box">
            <strong>ANTI-RETALIATION ASSURANCE:</strong>
            Dentulu will not retaliate against any patient for exercising their rights under HIPAA or
            applicable law, including the right to file a complaint with HHS Office for Civil Rights.
        </div>


        <h2>XIII. MULTI-STATE OPERATIONS &amp; SUBCONTRACTED PROVIDER NETWORKS</h2>

        <h3>A. Cross-State Care Disclosures</h3>

        <p>
            Dentulu operates as a national teledentistry and healthcare marketplace platform serving patients
            and providers across all fifty (50) U.S. states, the District of Columbia, and U.S. territories.
        </p>

        <ul>
            <li>The treating Network Provider may be licensed in a different state than the patient’s state of residence or location at the time of service;</li>
            <li>Teledentistry and telehealth services are subject to the dental and medical practice laws of both the patient’s state and the provider’s state of licensure, as applicable;</li>
            <li>State laws governing teledentistry, informed consent, prescribing, privacy, and patient rights vary significantly across jurisdictions;</li>
            <li>Where state law is more protective of patient rights or imposes greater restrictions on PHI use than HIPAA, Dentulu will comply with the more stringent standard;</li>
            <li>Your PHI may be transmitted across state lines in connection with teledentistry services, multi-provider care coordination, and Business Associate operations;</li>
            <li>Dentulu does not guarantee the availability of teledentistry services in all states, as state-specific regulatory requirements may restrict or require modification of certain services; and</li>
            <li>Applicable state-specific privacy addenda will be provided upon request for states with heightened health data privacy laws.</li>
        </ul>


        <h3>B. Subcontracted Physician and Provider Network</h3>

        <ul>
            <li>Subcontracted providers operate as independent contractors of Dentulu and/or of independent physician networks or group practices that contract with Dentulu;</li>
            <li>Subcontracted providers are licensed in the jurisdictions where they practice and are responsible for their own professional credentials, malpractice coverage, and clinical standards;</li>
            <li>Dentulu’s subcontracting of provider services does not make Dentulu the employer, supervisor, or professional guarantor of subcontracted providers;</li>
            <li>PHI shared with subcontracted provider networks is subject to Business Associate Agreements or treatment-purpose disclosures, as applicable under HIPAA;</li>
            <li>Patients will be informed of the identity of the treating provider before or at the time of service; and</li>
            <li>Dentulu maintains a credentialing and quality oversight process for Network Providers, but credentialing does not guarantee clinical outcomes or create liability for Dentulu with respect to individual provider performance.</li>
        </ul>


        <h3>C. International Operations</h3>

        <p>
            At this time, Dentulu’s primary operations and patient services are limited to the United States.
            Where Dentulu engages international Business Associates or subcontractors for technology, data
            processing, or administrative support, Dentulu will ensure that appropriate data transfer
            mechanisms and contractual protections are in place to protect the confidentiality and integrity of PHI.
        </p>


        <h2>XIV. PLATFORM LIABILITY SHIELD — LIMITATIONS OF DENTULU’S LIABILITY</h2>

        <h3>A. No Clinical Liability for Platform-Facilitated Services</h3>

        <p>
            Dentulu facilitates access to licensed healthcare providers through its platform but does not
            itself provide clinical dental or medical care, diagnoses, or treatment, except in limited
            circumstances where Dentulu directly employs clinicians.
        </p>

        <h3>B. No Liability for Third-Party Systems</h3>

        <p>
            Dentulu is not responsible for failures, breaches, outages, errors, or performance issues
            affecting third-party systems, platforms, networks, or services used in connection with Dentulu’s platform.
        </p>

        <h3>C. No Warranty on Platform Availability</h3>

        <p>
            <strong>
                DENTULU MAKES NO WARRANTY THAT THE PLATFORM WILL BE AVAILABLE, ERROR-FREE, SECURE,
                OR UNINTERRUPTED AT ALL TIMES.
            </strong>
            The platform is provided on an “as is” and “as available” basis.
        </p>

        <h3>D. Limitation of Damages</h3>

        <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, DENTULU’S TOTAL CUMULATIVE LIABILITY
            TO ANY PATIENT FOR ANY CLAIM ARISING OUT OF OR RELATING TO THE PLATFORM, THIS NOTICE,
            OR DENTULU’S PRIVACY PRACTICES SHALL NOT EXCEED THE GREATER OF:
            (i) THE TOTAL AMOUNT PAID BY THE PATIENT TO DENTULU IN THE TWELVE (12) MONTHS PRECEDING
            THE CLAIM; OR (ii) ONE HUNDRED DOLLARS ($100.00).
        </p>

        <h3>E. Indemnification</h3>

        <p>
            You agree to indemnify, defend, and hold harmless Dentulu Inc. and its officers, directors,
            employees, affiliates, agents, licensors, and successors from any claims, damages, losses,
            liabilities, costs, and expenses arising from your use of the Dentulu platform, your violation
            of this Notice or applicable law, your submission of inaccurate information, or clinical services
            obtained through the Dentulu platform.
        </p>


        <h2>XV. DISPUTE RESOLUTION — BINDING ARBITRATION &amp; CLASS ACTION WAIVER</h2>

        <div class="critical-notice">
            <strong>IMPORTANT — PLEASE READ CAREFULLY:</strong>
            This Section contains a binding arbitration clause and class action waiver.
            By using the Dentulu platform or receiving services facilitated through Dentulu,
            you agree that any dispute arising from or relating to this Notice, your PHI,
            your use of the Dentulu platform, or any services obtained through Dentulu will be
            resolved by binding individual arbitration, and you waive your right to a jury trial
            and to participate in a class action.
        </div>


        <h3>A. Agreement to Arbitrate</h3>

        <p>
            Except as otherwise provided in Section XV(E) below, you and Dentulu agree that any and all
            disputes, claims, or controversies arising out of or relating to this Notice of Privacy Practices
            or any companion document; Dentulu’s collection, use, or disclosure of your PHI; your use of
            the Dentulu platform; any teledentistry, marketplace, or care-coordination services facilitated
            by Dentulu; or any breach, termination, or validity of this Notice, shall be resolved exclusively
            by final and binding individual arbitration, rather than in court.
        </p>


        <h3>B. Governing Rules — Federal Arbitration Act</h3>

        <p>
            This arbitration agreement is governed by the Federal Arbitration Act (FAA),
            9 U.S.C. §§ 1 et seq., and the arbitration shall be administered by the American Arbitration
            Association (AAA) under its Consumer Arbitration Rules, as modified herein.
        </p>


        <h3>C. Location and Format</h3>

        <p>
            Arbitration may be conducted: (i) in person in Los Angeles, California;
            (ii) by telephone; (iii) by videoconference; or (iv) solely on written submissions,
            as determined by the arbitrator.
        </p>


        <h3>D. Class Action Waiver</h3>

        <p>
            <strong>
                YOU AND DENTULU EACH AGREE THAT ANY DISPUTE RESOLUTION PROCEEDINGS, WHETHER IN
                ARBITRATION OR IN COURT, WILL BE CONDUCTED ONLY ON AN INDIVIDUAL BASIS AND NOT
                IN A CLASS, CONSOLIDATED, OR REPRESENTATIVE ACTION.
            </strong>
        </p>


        <h3>E. Exceptions to Arbitration</h3>

        <ul>
            <li>Claims subject to the exclusive jurisdiction of a government agency, including HIPAA complaints filed with HHS Office for Civil Rights;</li>
            <li>Claims for injunctive or other equitable relief for actual or threatened infringement, misappropriation, or violation of intellectual property rights;</li>
            <li>Claims that may not be subject to arbitration under applicable law; and</li>
            <li>Small claims court actions within the jurisdictional limits of such court.</li>
        </ul>


        <h3>F. Severability</h3>

        <p>
            If any portion of this arbitration clause (other than the Class Action Waiver) is found
            unenforceable, that portion shall be severed and the remaining arbitration provisions
            shall continue in full force.
        </p>


        <h3>G. Governing Law</h3>

        <p>
            This Notice and the arbitration agreement shall be governed by the laws of the State of Delaware,
            without regard to its conflict-of-laws principles, except that the Federal Arbitration Act governs
            the arbitrability of all disputes.
        </p>


        <h2>XVI. EFFECTIVE DATE, CHANGES &amp; MISCELLANEOUS PROVISIONS</h2>

        <h3>A. Effective Date and Revisions</h3>

        <p>
            This Notice is effective as of January 1, 2026 (Version 2026.2).
            Dentulu reserves the right to revise this Notice at any time.
        </p>

        <h3>B. Severability</h3>

        <p>
            If any provision of this Notice (other than HIPAA-mandated patient rights provisions,
            which may not be severed) is found invalid or unenforceable, the remaining provisions
            shall continue in full force and effect.
        </p>

        <h3>C. Entire Agreement</h3>

        <p>
            This Notice, together with Dentulu’s Platform Terms of Service, Platform Privacy Policy,
            and any applicable signed authorizations or consents, constitutes the entire agreement
            between you and Dentulu with respect to the handling of your PHI and supersedes all prior
            notices, representations, or agreements on this subject.
        </p>

        <h3>D. Waiver</h3>

        <p>
            Dentulu’s failure to enforce any provision of this Notice shall not constitute a waiver
            of its right to do so in the future.
        </p>


        <h3>E. Contact Information</h3>

        <table class="policy-table">
            <tbody>
                <tr>
                    <th>Privacy Officer</th>
                    <td><a href="mailto:support@dentulu.com">support@dentulu.com</a></td>
                </tr>
                <tr>
                    <th>Legal / Arbitration Notices</th>
                    <td><a href="mailto:legal@dentulu.com">legal@dentulu.com</a></td>
                </tr>
                <tr>
                    <th>Patient Rights Requests</th>
                    <td><a href="mailto:support@dentulu.com">support@dentulu.com</a> (written requests required)</td>
                </tr>
                <tr>
                    <th>Data Deletion Requests</th>
                    <td><a href="mailto:support@dentulu.com">support@dentulu.com</a></td>
                </tr>
                <tr>
                    <th>Mailing Address</th>
                    <td>Dentulu Inc., 2002 South Hoover Street, Los Angeles, CA 90007</td>
                </tr>
                <tr>
                    <th>Phone</th>
                    <td>888-905-0226</td>
                </tr>
                <tr>
                    <th>HHS Office for Civil Rights</th>
                    <td>
                        <a href="https://www.hhs.gov/ocr"
                           target="_blank"
                           rel="noopener noreferrer">
                            www.hhs.gov/ocr
                        </a>
                        | 1-800-368-1019
                    </td>
                </tr>
                <tr>
                    <th>Privacy Notice URL</th>
                    <td>
                        <a href="https://www.dentulu.com/privacypractices.html"
                           target="_blank"
                           rel="noopener noreferrer">
                            www.dentulu.com/privacypractices
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>



        <h2>ADDENDUM A — PATIENT DATA AUTHORIZATION ADDENDUM</h2>

        <h3>Optional Written Authorizations Under HIPAA § 164.508</h3>

        <p>
            <strong>NOTICE:</strong>
            This Addendum covers uses and disclosures of your PHI that require your written authorization
            under HIPAA (45 C.F.R. § 164.508). Signing is voluntary. Treatment will not be conditioned
            on whether you sign this Addendum, except as permitted by law. You may revoke any authorization
            at any time in writing.
        </p>


        <h3>Authorization 1: Research and Clinical Studies</h3>

        <p>
            I authorize Dentulu Inc. to use and disclose my PHI, including dental records, imaging,
            clinical notes, and outcomes data, for participation in research, clinical trials, and
            quality improvement research by Dentulu or its research partners.
        </p>


        <h3>Authorization 2: Marketing Communications</h3>

        <p>
            I authorize Dentulu Inc. to use my PHI to send me personalized marketing communications
            about Dentulu products, services, and partner offerings relevant to my oral health.
        </p>


        <h3>Authorization 3: Sale of PHI</h3>

        <p>
            I authorize Dentulu Inc. to share my identifiable PHI with the following third parties
            for purposes beyond treatment, payment, or operations:
            ________________________________________________.
            Dentulu will be compensated as follows:
            ________________________________________________.
        </p>


        <h3>Authorization 4: Disclosure to Non-Healthcare Third Parties</h3>

        <p>
            I authorize disclosure to:
            Name/Organization: ________________________________
            Relationship: _____________________________________
            Purpose: __________________________________________
        </p>


        <h3>Authorization 5: Photos, Videos, and Testimonials</h3>

        <p>
            I authorize use of my photographs, videos, or recordings, including images of my oral cavity
            or dental work, for educational, promotional, or marketing purposes on Dentulu’s platform
            and marketing materials.
        </p>


        <h3>Right to Revoke</h3>

        <p>
            You may revoke any Authorization at any time by sending written notice to
            <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
            Revocation is not effective to the extent Dentulu has already acted in reliance on the Authorization.
        </p>

        <p>
            <strong>Authorizations selected:</strong>
            1 | 2 | 3 | 4 | 5 | ALL | NONE
        </p>



        <h2>ADDENDUM B — AI &amp; DATA USE CONSENT</h2>

        <p>
            <strong>NOTICE:</strong>
            This AI &amp; Data Use Consent is voluntary and separate from your treatment.
            Dentulu uses de-identified and aggregated data for AI development without this Consent.
        </p>


        <h3>1. Scope of AI/ML Uses Covered</h3>

        <p>
            By agreeing to this Consent, you authorize Dentulu Inc. to use your identifiable PHI for:
        </p>

        <ul>
            <li>Training, validating, and improving supervised and unsupervised ML models for oral health diagnosis and care;</li>
            <li>Developing AI algorithms for dental image analysis, caries detection, periodontal risk scoring, and related clinical applications;</li>
            <li>Training NLP models using de-identified or pseudonymized clinical notes and patient communications;</li>
            <li>Improving AI-assisted triage and care routing systems; and</li>
            <li>Other AI/ML activities specifically described to you at the time of consent.</li>
        </ul>


        <h3>2. AI Risk Acknowledgment</h3>

        <p>
            <strong>PATIENT ACKNOWLEDGMENT:</strong>
            By agreeing to this AI &amp; Data Use Consent, you acknowledge that you have read and understood
            Section VII of the Notice of Privacy Practices.
        </p>


        <h3>3. Data Protections</h3>

        <p>
            Dentulu will: limit use to purposes described herein; execute BAAs with AI vendors accessing
            identifiable PHI; apply access controls, encryption, and audit logging; not sell identifiable
            PHI for AI training; and notify you of material changes.
        </p>


        <h3>4. Perpetual Data Rights Acknowledgment</h3>

        <p>
            You acknowledge that any de-identified, aggregated, or derived data generated from your PHI
            in connection with AI development may be retained and used by Dentulu on a perpetual,
            irrevocable basis as described in Section VIII of the NPP, without compensation owed to you.
        </p>


        <h3>5. Duration and Revocation</h3>

        <p>
            Effective from the date of acceptance until revoked.
            To revoke, send written notice to
            <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
            Revocation is not retroactive.
        </p>



        <h2>ADDENDUM C — TELEHEALTH CONSENT</h2>

        <h3>TELEDENTISTRY &amp; TELEHEALTH INFORMED CONSENT</h3>

        <p>
            This Consent applies to your use of Dentulu’s teledentistry and telehealth services,
            including live video consultations, asynchronous (store-and-forward) consultations,
            remote monitoring, AI-assisted screenings, and related digital health services.
        </p>


        <h3>1. Nature of Teledentistry Services</h3>

        <p>
            Teledentistry uses electronic communication technologies including video conferencing,
            digital imaging, asynchronous messaging, and AI-assisted tools for dental care delivery.
        </p>


        <h3>2. Technology Limitations — Patient Risk Assumption</h3>

        <div class="critical-notice">
            <strong>
                CRITICAL RISK DISCLOSURE: TELEDENTISTRY HAS INHERENT LIMITATIONS COMPARED TO
                IN-PERSON DENTAL EXAMINATION.
            </strong>
        </div>

        <ul>
            <li>Teledentistry CANNOT fully replicate an in-person clinical examination.</li>
            <li>A remote consultation DOES NOT GUARANTEE A DIAGNOSIS.</li>
            <li>IMAGE AND VIDEO QUALITY LIMITATIONS may impair the provider’s ability to visualize and assess your oral condition.</li>
            <li>TECHNOLOGY FAILURES including network outages, software malfunctions, hardware failures, poor internet connectivity, and session interruptions may prevent or degrade the teledentistry consultation.</li>
            <li>YOU ASSUME THE RISK of technology limitations.</li>
            <li>DELAYS IN DIAGNOSIS OR TREATMENT are possible due to the asynchronous nature of certain teledentistry modalities.</li>
            <li>DENTULU MAKES NO GUARANTEE that teledentistry services will result in the same outcome as in-person care.</li>
            <li>Certain dental conditions REQUIRE IN-PERSON EVALUATION AND TREATMENT.</li>
            <li>EMERGENCY CONDITIONS must always be addressed in person or at an emergency facility.</li>
        </ul>


        <h3>3. Privacy and Security</h3>

        <p>
            Dentulu uses HIPAA-compliant platforms with encryption and access controls.
            However, no internet-based communication is 100% secure, and Dentulu cannot guarantee
            absolute privacy of electronic transmissions.
        </p>


        <h3>4. State Law Compliance</h3>

        <p>
            Teledentistry is subject to state dental and medical practice laws, which vary by jurisdiction.
            Dentulu providers are licensed in states where they practice and comply with applicable state
            teledentistry regulations.
        </p>


        <h3>5. Patient Affirmative Representations</h3>

        <ul>
            <li>You have read and understood the technology limitations and risk disclosures in Section 2 above;</li>
            <li>You voluntarily and knowingly assume the risks described herein;</li>
            <li>You consent to receive teledentistry services subject to those limitations; and</li>
            <li>You understand that teledentistry may be provided by Network Providers who are independent contractors.</li>
        </ul>



        <h2>ADDENDUM D — THIRD-PARTY SHARING CONSENT</h2>

        <p>
            <strong>NOTICE:</strong>
            Much of Dentulu’s sharing of your PHI with third parties is permitted by HIPAA without
            your consent (for treatment, payment, and healthcare operations).
        </p>

        <h3>THIRD-PARTY SHARING CONSENT</h3>

        <p>
            If you do not consent to any particular category, please check Decline for that category below.
            These preferences may be updated at any time by contacting
            <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
        </p>

        <table class="policy-table">
            <thead>
                <tr>
                    <th>Third-Party Category</th>
                    <th>Decline</th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>Dental product/service companies (Dentulu partners) for relevant oral health offers</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Employer wellness programs — limited to treatment and participation data</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Life, disability, or supplemental health insurers beyond your current insurer</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Family members or designated caregivers for care coordination</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Patient advocacy organizations or support groups relevant to your condition</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Academic institutions or dental schools for educational purposes</td>
                    <td></td>
                </tr>
                <tr>
                    <td>Non-HIPAA-covered health apps or digital health platforms you select</td>
                    <td></td>
                </tr>
            </tbody>
        </table>




        <h2>ADDENDUM E — PLATFORM TERMS CROSS-REFERENCE</h2>

        <h3>Governing Document Interrelationship Guide</h3>

        <h3>PLATFORM TERMS CROSS-REFERENCE</h3>

        <p>
            This Addendum identifies the sections of Dentulu’s Platform Terms of Service,
            Privacy Policy, and related agreements that intersect with this NPP and companion documents.
        </p>


        <h3>1. NPP and Platform Privacy Policy Relationship</h3>

        <p>
            Dentulu maintains both this HIPAA NPP (governing PHI) and a separate Platform Privacy Policy
            governing non-PHI data (usage data, cookies, device data), available at
            <a href="https://app.dentulu.com/page/privacy-policy"
               target="_blank"
               rel="noopener noreferrer">
                https://app.dentulu.com/page/privacy-policy
            </a>.
            This NPP governs clinical health information; the Platform Privacy Policy governs general
            platform usage data.
        </p>


        <h3>2. Platform Terms of Service — Key Cross-References</h3>

        <table class="policy-table">
            <thead>
                <tr>
                    <th>Terms Section</th>
                    <th>Subject Matter</th>
                    <th>Related NPP Section</th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>Sec. 3 — User Data</td>
                    <td>Collection &amp; storage of account and usage data</td>
                    <td>NPP Sections III, VIII</td>
                </tr>
                <tr>
                    <td>Sec. 4 — Healthcare Data</td>
                    <td>PHI handling; HIPAA compliance</td>
                    <td>NPP Sections I–XVI</td>
                </tr>
                <tr>
                    <td>Sec. 5 — Platform Nature</td>
                    <td>Technology facilitator; independent contractor providers</td>
                    <td>NPP Section I(A)(B); XIV</td>
                </tr>
                <tr>
                    <td>Sec. 6 — AI &amp; Automation</td>
                    <td>AI features; no warranty; human oversight</td>
                    <td>NPP Section VII; Addendum B</td>
                </tr>
                <tr>
                    <td>Sec. 7 — Third-Party</td>
                    <td>API partners, vendors, liability shield</td>
                    <td>NPP Sections VI; XIV</td>
                </tr>
                <tr>
                    <td>Sec. 8 — De-identified Data</td>
                    <td>Dentulu data rights; perpetual/irrevocable</td>
                    <td>NPP Section VIII; Addendum B</td>
                </tr>
                <tr>
                    <td>Sec. 9 — Patient Rights</td>
                    <td>Account access, portability, deletion</td>
                    <td>NPP Section IX</td>
                </tr>
                <tr>
                    <td>Sec. 10 — Breach Response</td>
                    <td>Security incident response</td>
                    <td>NPP Section IX(G); XII</td>
                </tr>
                <tr>
                    <td>Sec. 11 — Telehealth Terms</td>
                    <td>Teledentistry; risk assumption; state law</td>
                    <td>Addendum C; NPP XIII</td>
                </tr>
                <tr>
                    <td>Sec. 12 — Marketplace Terms</td>
                    <td>Provider marketplace; patient-provider relationship</td>
                    <td>NPP Sections I(A); IV–V</td>
                </tr>
                <tr>
                    <td>Sec. 13 — Liability</td>
                    <td>Platform liability shield; damages cap</td>
                    <td>NPP Section XIV</td>
                </tr>
                <tr>
                    <td>Sec. 14 — Dispute Resolution</td>
                    <td>FAA arbitration; class action waiver</td>
                    <td>NPP Section XV</td>
                </tr>
                <tr>
                    <td>Sec. 15 — Multi-State</td>
                    <td>Cross-state; subcontracted networks</td>
                    <td>NPP Section XIII</td>
                </tr>
                <tr>
                    <td>Sec. 16 — Changes</td>
                    <td>Material change notification</td>
                    <td>NPP Section XVI</td>
                </tr>
            </tbody>
        </table>


        <h3>3. Governing Document Hierarchy</h3>

        <ol>
            <li>45 C.F.R. Parts 160 &amp; 164 (HIPAA/HITECH) and applicable state law (supreme);</li>
            <li>This Notice of Privacy Practices (for PHI);</li>
            <li>Platform Terms of Service (for platform use);</li>
            <li>Platform Privacy Policy (for non-PHI data); and</li>
            <li>Signed Addenda and Authorizations (for specific authorized uses).</li>
        </ol>


        <h3>4. State-Specific Addenda</h3>

        <p>
            State-specific privacy addenda are available upon request for patients in:
            California (CMIA, CPRA), Texas (THIPA), New York (SHIELD Act), Illinois (BIPA),
            Virginia (VCDPA), Colorado (CPA), Washington (My Health MY Data Act), Nevada,
            and any other state with healthcare-specific privacy laws more stringent than HIPAA.
            Contact <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
        </p>



        <h2>NOTICE OF ACCEPTANCE</h2>

        <div class="acceptance-box">

            <p>
                By signing below, I acknowledge that I have received, read, and understand this Notice
                of Privacy Practices and all companion Addenda (Addenda A through E), and I agree to be
                bound by all terms, practices, disclosures, limitations, and conditions set forth herein —
                including the binding arbitration clause and class action waiver in Section XV — on behalf
                of myself and, where applicable, any minor or dependent for whom I am the legal guardian
                or authorized representative.
            </p>

            <p>
                I understand that my signature below constitutes my sole and complete acceptance of this
                entire document package, that no further consent forms or acknowledgment documents are
                required, and that continued use of any Dentulu Inc. service — including any website,
                mobile application, teledentistry consultation, dental marketplace, care-coordination
                service, or AI-assisted tool — following any posted revision to this Notice constitutes
                my ongoing acceptance of the then-current version.
            </p>

            <p>
                This Notice is available at all times at
                <a href="https://www.dentulu.com/privacypractices.html"
                   target="_blank"
                   rel="noopener noreferrer">
                    www.dentulu.com/privacypractices
                </a>
                and in paper form upon request to
                <a href="mailto:support@dentulu.com">support@dentulu.com</a>.
            </p>

        </div>

    </div>

</main>
        );
}